import React from 'react'

import {
    ChatFieldsFragment,
    ChatMessageFieldsFragment,
} from '~graphql/generated/graphql'
import MessageContent from './message-content'
import { Box } from '@chakra-ui/react'
import SharedInfoText from '~components/shared/texts/shared-info-text'

interface MessagesListProps {
    messages: ChatMessageFieldsFragment[]
    refetchMessages: () => void
    chat: ChatFieldsFragment
    showLocationTags?: boolean
}

const MessagesList: React.FC<MessagesListProps> = ({
    messages,
    refetchMessages,
    chat,
    showLocationTags,
}) => {
    return (
        <Box pb={6}>
            {messages.map((message, index) => (
                <MessageContent
                    key={message.id}
                    message={message}
                    refetchMessages={refetchMessages}
                    messageIndex={index}
                    allMessages={messages}
                    chat={chat}
                    showLocationTag={
                        showLocationTags && message.chat.id !== chat.id
                    }
                />
            ))}
        </Box>
    )
}

export default MessagesList
